import React from 'react';
import { Leaf, Heart, Recycle, Users } from 'lucide-react';
import '../../styles/GarbaBioSection.css';

const GarbaBioSection = ({ data }) => {
  return (
    <section className="garba-bio-section section-animate">
      <div className="container">
        <h2 className="section-title">{data.title}</h2>
        
        <div className="garba-bio-grid">
          <div className="garba-bio-content">
            <p className="garba-bio-description">{data.description}</p>
            
            <div className="garba-bio-features">
              {data.features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon">
                    {index === 0 && <Leaf />}
                    {index === 1 && <Heart />}
                    {index === 2 && <Users />}
                    {index === 3 && <Recycle />}
                  </div>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="garba-bio-gallery">
            {data.images.map((image, index) => (
              <div 
                key={index} 
                className="gallery-item"
              >
                <img 
                  src={image} 
                  alt={`Garba-Bio ${index + 1}`}
                  className="gallery-image"
                />
                <div className="image-overlay">
                  <span className="overlay-text">
                    {index === 0 ? "En cuisine" : 
                     index === 1 ? "Festival culinaire" : 
                     "Garba-Bio signature"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GarbaBioSection;